import React, { useState } from "react";
import { hideShowProgramme } from "../../../redux/actions/immobilierActions";
import { useDispatch } from "react-redux";

const HideProgram = ({ programme, handleShowHideProgram }) => {
  const dispatch = useDispatch();

  const [showMissing, setShowMissing] = useState(false);
  const handleShowMissing = (e) => {
    e.stopPropagation();
    setShowMissing(true);
  };
  const handleHideMissing = (e) => {
    e.stopPropagation();
    setShowMissing(false);
  };
  return (
    <div
      className="position-absolute d-flex justify-content-center align-items-center border"
      onClick={(e) => {
        e.stopPropagation();
        handleShowHideProgram(programme);
      }}
      onMouseEnter={(e) => handleShowMissing(e)}
      onMouseLeave={(e) => handleHideMissing(e)}
      style={{
        top: -10,
        right: -20,
        borderRadius: "50%",
        backgroundColor: "#ffffffff",
        width: "42px",
        height: "42px",
      }}
    >
      <svg
        className="hideEye"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.25 9.14969C18.94 5.51969 15.56 3.42969 12 3.42969C10.22 3.42969 8.49 3.94969 6.91 4.91969C5.33 5.89969 3.91 7.32969 2.75 9.14969C1.75 10.7197 1.75 13.2697 2.75 14.8397C5.06 18.4797 8.44 20.5597 12 20.5597C13.78 20.5597 15.51 20.0397 17.09 19.0697C18.67 18.0897 20.09 16.6597 21.25 14.8397C22.25 13.2797 22.25 10.7197 21.25 9.14969ZM12 16.0397C9.76 16.0397 7.96 14.2297 7.96 11.9997C7.96 9.76969 9.76 7.95969 12 7.95969C14.24 7.95969 16.04 9.76969 16.04 11.9997C16.04 14.2297 14.24 16.0397 12 16.0397Z"
          fill={programme.hidden ? "#ed65a3" : "#95ce00"}
        />
        <path
          d="M11.9984 9.14062C10.4284 9.14062 9.14844 10.4206 9.14844 12.0006C9.14844 13.5706 10.4284 14.8506 11.9984 14.8506C13.5684 14.8506 14.8584 13.5706 14.8584 12.0006C14.8584 10.4306 13.5684 9.14062 11.9984 9.14062Z"
          fill={programme.hidden ? "#ed65a3" : "#95ce00"}
        />
      </svg>
      {showMissing && (
        <div
          className="position-absolute text-start f12"
          style={{
            fontSize: "12px",
            width: "max-content",
            top: "100%",
            right: "0",
            zIndex: 10000,
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        >
          <div className="bold">
            {programme.hidden ? "Programme masqué" : "Programme visible"}
          </div>
        </div>
      )}
    </div>
  );
};

export default HideProgram;
